export enum SdkRoleType {
    App = "App",
    External = "External",
}

export enum EventType {
    PAGE_PREPARED = "PAGE_PREPARED",
    START_LOADING = "START_LOADING",
    STOP_LOADING = "STOP_LOADING",
    INIT_CONFIG = "INIT_CONFIG",
    LOADING_FILE_START = "LOADING_FILE_START",
    LOADING_FILE_SUCCESS = "LOADING_FILE_SUCCESS",
    LOADING_FILE_FAIL = "LOADING_FILE_FAIL",
    OPEN_FILE = "OPEN_FILE",
    START_SHARE = "START_SHARE",
    BACK_TO_HOME = "BACK_TO_HOME",
}

export enum SdkMessageChannel {
    PROMISE = "Max-Sdk-Promise",
    REPLY = "Max-Sdk-Reply",
    NORMAL = "Max-Sdk",
}

export interface Listener {
    handler: Function;
    disposable: boolean;
}

export const SDK_PROMISE_ERROR = "sdk-promise-error";

export const SDK_PROMISE_TIMEOUT = "sdk-promise-timeout";

export const UNIMPLEMENTED_FUNCTION_ERROR = new Error("you must implement the specific function");

export class EventEmitter {
    _name: string;
    _listenersByEvent: { [key: string]: Listener[] } = {};

    constructor(name: string) {
        this._name = name;
    }

    addListener(event: string, listener: Function, disposable: boolean = true) {
        if (!this._listenersByEvent[event]) {
            this._listenersByEvent[event] = [];
        }
        if (!disposable) {
            this.removeListener(event, listener);
        }
        this._listenersByEvent[event].push({
            handler: listener,
            disposable: false,
        });
    }

    on(event: string, listener: Function, disposable: boolean = true) {
        this.addListener(event, listener, disposable);
    }

    once(event: string, listener: Function) {
        if (!this._listenersByEvent[event]) {
            this._listenersByEvent[event] = [];
        }
        this._listenersByEvent[event].push({
            handler: listener,
            disposable: true,
        });
    }

    removeListener(event: string, listener: Function) {
        const listeners = this._listenersByEvent[event];
        if (listeners) {
            const index = listeners.findIndex((l) => l.handler === listener);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        }
    }

    off(event: string, listener: Function) {
        this.removeListener(event, listener);
    }

    removeAllListener(event: string) {
        delete this._listenersByEvent[event];
    }

    trigger(event: string, ...args: any[]) {
        if (this._listenersByEvent[event]) {
            for (const listener of this._listenersByEvent[event]) {
                listener.handler(...args);
            }
            this._listenersByEvent[event] = this._listenersByEvent[event].filter((listener) => !listener.disposable);
        }
    }

    emit(event: string, ...args: any[]) {
        this.trigger(event, ...args);
    }
}
